export enum UpdatePriorityEnum {
  Mandatory = 0,
  Optional = 1,
  Deadline = 2
}